import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Typography,
  Divider,
  Button,
  Fab,
  Grid,
  colors
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { AwesomeButtonSocial } from 'react-awesome-button';
import AwesomeButtonStyles from 'react-awesome-button/src/styles/styles.scss';
import {postIsInterestedUpdate, postChangeProfilePictureAPIReq, postRemoveProfilePictureAPIReq, postChangeCVAPIReq, } from '../../../../utils/requests';
import {Add, RemoveCircle} from '@material-ui/icons';

import Switch from '@material-ui/core/Switch';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from '@material-ui/core/CircularProgress';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles(theme => ({
  root: {},
  details: {
    display: 'flex'
  },
  avatar: {
    height: 110,
    width: 100,
  },
  progress: {
    marginTop: theme.spacing(2)
  },
  uploadButton: {
    marginRight: theme.spacing(2)
  },
  browseButton: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
  red: {
    color: colors.red[600]
  }
}));

const AccountProfile = props => {

  const { className, data,...rest } = props;
  // console.log(data)
  const [state, setState] = React.useState({
    isInterested: data.is_interested,
  });
  const [openErrorSnack, setOpenErrorSnack] = React.useState(false);
  const [openSuccessSnack, setOpenSuccessSnack] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(0);
  const [message, setMessage] = React.useState('');
  const [reload, setReload] = React.useState(0);

  const classes = useStyles();
  const handleChange = (event) => {
    let opposite = !state.isInterested;
    return postIsInterestedUpdate(opposite)
      .then((res) => {
        if(res)
          setState({isInterested: opposite});
      })
  };
  
  const handleCloseSuccessSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSuccessSnack(false);
  };

  const handleCloseErrorSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenErrorSnack(false);
  };

  const refresh = () => {
    window.location.reload(false);
  }

  const onPictureFileChange = (e) => {
    setUploadProgress(5);
    return postChangeProfilePictureAPIReq(e.target.files[0], setUploadProgress)
      .then((isSuccess) => {
        // console.log(isSuccess)
        if(isSuccess === true) {
          setMessage("Picture")
          setOpenSuccessSnack(true);
          refresh() 
        }
        else
          setMessage(isSuccess.error.message)
          setOpenErrorSnack(true);
      })
  };

  const onRemovePicture = () => {
    return postRemoveProfilePictureAPIReq()
      .then((isSuccess) => {
        if(isSuccess){
          setMessage("Picture")
          setOpenSuccessSnack(true) 
          refresh()
        }
        else
          setOpenErrorSnack(true);
      })
  }

  const onCvChange = (e) => {
    setUploadProgress(5);
    return postChangeCVAPIReq(e.target.files[0], setUploadProgress)
      .then((isSuccess) => {
        if(isSuccess){
          setMessage("CV")
          setOpenSuccessSnack(true);
          refresh()
        }
        else
          setOpenErrorSnack(true);
      })
  };

  return (
    <div>
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent>
          <div className={classes.details}>
            <div>
              <Typography
                gutterBottom
                variant="h3"
              >
                {data.first_name} {data.last_name}, {data.school}
              </Typography>
              <Grid
                container
              >
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <TextField
                    defaultValue={data.major}
                    id="standard-read-only-input"
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Major"
                    margin="dense"
                    style={{marginRight: 10}}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <TextField
                    defaultValue={data.minor}
                    id="standard-read-only-input"
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Minor"
                    margin="dense"
                    variant="outlined"
                  />
                </Grid>
              </Grid>

              <Grid
                container
              >
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <TextField
                    defaultValue={data.email}
                    id="standard-read-only-input"
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Email"
                    margin="dense"
                    style={{marginRight: 10,  marginBottom: '1rem'}}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <TextField
                    defaultValue={data.phone_number}
                    id="standard-read-only-input"
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Phone"
                    margin="dense"
                    variant="outlined"
                  />
                </Grid>
              </Grid>

              <Divider
                style={{marginBottom: '1rem'}}
                variant="middle"
              />
              <Grid
                container
                spacing={24}
                style={{alignItems: 'center', justify: 'center', justifyContent: 'center', justifyItems: 'center'}}
              >
                <Grid
                  item
                  md={6}
                  xs={6}

                >
                  {
                    (data.linkedin_username && data.linkedin_username!=='')?
                      <AwesomeButtonSocial
                        cssModule={AwesomeButtonStyles}
                        style={{width: '95%'}}
                        type="linkedin"
                        href={"https://www.linkedin.com/in/" + data.linkedin_username}
                        target="_blank"
                      />
                      :<div />
                  }
                </Grid>

                <Grid
                  item
                  md={6}
                  xs={6}
                >

                  {
                    (data.github_username && data.github_username!=='')?
                      <AwesomeButtonSocial
                        cssModule={AwesomeButtonStyles}
                        style={{width: '100%'}}
                        type="github"
                        href={"https://github.com/" + data.github_username}
                        target="_blank"
                      >
                        {data.is_interested}
                      </AwesomeButtonSocial>
                      :<div />

                  }
                </Grid>

              </Grid>
              {
                (data.cv_url && data.cv_url!=='')?
                  <Button variant="contained" color="primary" onClick={()=>{ window.open(data.cv_url, '_blank');}} style={{marginTop: 20, width: '100%'}}>
                    Download CV
                  </Button>
                  :<div />
              }
            </div>
            <div style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: 20}}>
              <div style={{alignItems: 'center', justifyContent: 'center', display: 'flex',
                flexDirection: 'column'}}>
                <Avatar
                  src={data.profile_picture}
                  style={{width:150, height: 150, marginTop: 20}}
                />
                {data.profile_picture?
                <div
                  style={{marginTop: -30, paddingLeft: 50}}
                >
                  <Fab onClick={onRemovePicture} size="small" color="secondary" aria-label="remove">
                  <RemoveCircle />
                  </Fab>
                  
                  <div></div>
                </div>
                  :
                  <div></div>
                } 
              </div>
              <Typography
                gutterBottom
                style={{textAlign:'center',  marginTop: 20}}
                variant="h5"
              >
                Actively Searching for an Opportunity
              </Typography>
              <div
                style={{ display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'}}
              >
                <Switch
                  checked={state.isInterested}
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                  name="checkedA"
                  onChange={handleChange}
                  style={{ }}
                />
              </div>
            </div>
          </div>
          <MuiAlert severity="info">Please note that your information will be shared with Alumni if you activate the "Interested" option</MuiAlert>
        </CardContent>
        <Divider />
        <CardActions>


          <input
            accept=".pdf"
            className={classes.input}
            id="contained-button-cv"
            multiple
            onChange={onCvChange}
            type="file"
          />
          <label htmlFor="contained-button-cv">
            <Button
              className={classes.browseButton}
              component="span"
              variant="raised"
            >
              {data.cv_url? "Change CV" : "Upload CV"}
            </Button>
          </label>

          <input
            accept=".jpg,.png"
            className={classes.input}
            id="contained-button-picture"
            multiple
            onChange={onPictureFileChange}
            type="file"
          />
          <label htmlFor="contained-button-picture">
            <Button
              className={classes.browseButton}
              component="span"
              variant="raised"
            >
                {data.profile_picture? "Change Picture" : "Upload Picture"}
            </Button>
          </label>
          <CircularProgress variant="static" value={uploadProgress} />
        </CardActions>
      </Card>
      <Snackbar
        autoHideDuration={6000}
        onClose={handleCloseErrorSnack}
        open={openErrorSnack}
      >
        <Alert
          onClose={handleCloseErrorSnack}
          severity="error"
        >
          An Error Has Occurred: {message}
        </Alert>
      </Snackbar>
      <Snackbar
        autoHideDuration={6000}
        onClose={handleCloseSuccessSnack}
        open={openSuccessSnack}
      >
        <Alert
          onClose={handleCloseSuccessSnack}
          severity="success"
        >
          {message} Updated Successfully 
        </Alert>
      </Snackbar>
    </div>
  );
};

AccountProfile.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array
};

export default AccountProfile;
